import { service } from '@/utils/request'
class wow {
  // 编辑器列表
  static getEditorList (params) {
    return service.get(`/api/charactermaterial/editor_list`, { params })
  }
  // 获取搭配列表
  static getMatchList (params) {
    return service.get(`/api/charactermaterial/collocation_list`, { params })
  }
  // 保存json 数据
  static worksSave (params) {
    return service.post(`/api/charactermaterial/save_work`, params)
  }

  // 保存json 数据
  static getWorksInfo (params) {
    return service.get(`/api/charactermaterial/work_info`, { params })
  }
}

export default wow
